/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Group112.css";
import imagex from "../../static/img/45924475844-80831eb37e-3k-1@1x.jpg";
function Group112(props) {
  const { className } = props;

  return (
    <div className={`group-112 ${className || ""}`}>
      <img className="x45924475844_80831eb37e_3k" src={imagex} />
    </div>
  );
}

export default Group112;
